module.exports = __webpack_public_path__ + "img/home_bg_03_2.b8d8d832.png";